import { DOWNLOAD_API } from '../api'
import { onDownloadLinkClick } from '../components/core-v2'
import { getFactsheetDate } from './get-factsheet-date'

export const onDownloadFactSheetClick = portfolioId => {
  const todaysDate = new Date()
  const { month, year } = getFactsheetDate(todaysDate)

  onDownloadLinkClick({
    url: DOWNLOAD_API.exportPortfolioFactSheet({
      month,
      portfolioId,
      year
    }),
    filename: `${portfolioId}-factsheet-${month}-${year}.pdf`,
    method: 'GET'
  })
}
